import apis from 'SERVICE/APIs';

const GATWWAY_API = 'GATWWAY_API'; 
const UPLOAD_FILE = 'UPLOAD_FILE';
const GATWWAY_API_STATUS = 'GATWWAY_API_STATUS';

const doApi = params => dispatch => apis.gateWayApi.GetGateWayApi(params)
  .then((msgs) => {
    dispatch({
      type: GATWWAY_API,
      payload: msgs,
    });
    return msgs;
});

const doApiWithStatus = params => dispatch => apis.gateWayApi.GetGateWayApiWithStatus(params)
  .then((msgs) => {
    dispatch({
      type: GATWWAY_API_STATUS,
      payload: msgs,
    });
    return msgs;
});

const gateWayUploadFile = params => dispatch => apis.gateWayApi.UploadFile(params)
  .then((msgs) => {
    dispatch({
      type: UPLOAD_FILE,
      payload: msgs,
    });
    return msgs;
});


export default {
  doApi, gateWayUploadFile, doApiWithStatus
};

// ================================
// Action handlers for Reducer
// 本来更新 state 是 Reducer 的责任
// 但要把 ActionType 导出又引入实在太麻烦
// 且在 Reducer 中写 switch-case 实在太不优雅
// 故在此直接给出处理逻辑
// ================================
export const ACTION_HANDLERS = {
    [GATWWAY_API]: (result, { payload }) => ({ payload }),
    [UPLOAD_FILE]: (result, { payload }) => ({ payload }),
    [GATWWAY_API_STATUS]: (result, { payload }) => ({ payload }),
};



// WEBPACK FOOTER //
// ./src/redux/actions/common/apiGatewayAction.js